import { useFieldArray, useForm as useHookForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export type FormItem = {
  price: string;
  job_id: number;
  region_id: number;
  unchinSettei: string;
};

export type FormValue = {
  customer: FormItem[];
};

const useForm = (setError?) => {
  const schema = Yup.object().shape({
    customer: Yup.string(),
  });

  const form = useHookForm<FormValue>({
    resolver: yupResolver(schema),
    shouldFocusError: true,
  });

  const fieldArray = useFieldArray({
    name: 'customer',
    control: form.control,
  });

  const { fields } = fieldArray;

  return { ...form, fields, fieldArray };
};

export default useForm;
